export { default as ThreeDStockContentSearchInImageAllObjects } from './ThreeDStockContentSearchInImageAllObjects';
